import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz'

const EXCLUDED_RECORDED_RESPONSE_ADMINS = new Set([
    'prescott blackler',
])

const REPORT_TIME_ZONE = 'America/New_York'

const parseDateKey = (dateKey) => {
    const [year, month, day] = String(dateKey || '').split('-').map(Number)
    return { year, month, day }
}

const shiftDateKey = (dateKey, days) => {
    const { year, month, day } = parseDateKey(dateKey)
    const shifted = new Date(Date.UTC(year, month - 1, day + days))
    return formatInTimeZone(shifted, 'UTC', 'yyyy-MM-dd')
}

const getWeekWindowFromStartKey = (startDateKey) => {
    const endDateKey = shiftDateKey(startDateKey, 6)
    return {
        value: startDateKey,
        startDateKey,
        endDateKey,
        startAt: zonedTimeToUtc(`${startDateKey} 00:00:00.000`, REPORT_TIME_ZONE),
        endAt: zonedTimeToUtc(`${endDateKey} 23:59:59.999`, REPORT_TIME_ZONE),
    }
}

const formatWeekLabel = ({ startAt, endAt }) => {
    const startMonth = formatInTimeZone(startAt, REPORT_TIME_ZONE, 'MMM')
    const endMonth = formatInTimeZone(endAt, REPORT_TIME_ZONE, 'MMM')
    const startDay = formatInTimeZone(startAt, REPORT_TIME_ZONE, 'd')
    const endDay = formatInTimeZone(endAt, REPORT_TIME_ZONE, 'd')
    const startYear = formatInTimeZone(startAt, REPORT_TIME_ZONE, 'yyyy')
    const endYear = formatInTimeZone(endAt, REPORT_TIME_ZONE, 'yyyy')

    if (startYear !== endYear) {
        return `${startMonth} ${startDay}, ${startYear} – ${endMonth} ${endDay}, ${endYear}`
    }
    return startMonth === endMonth
        ? `${startMonth} ${startDay}–${endDay}, ${startYear}`
        : `${startMonth} ${startDay} – ${endMonth} ${endDay}, ${startYear}`
}

export const getInquirySmsWeekWindow = (value = new Date()) => {
    const current = value instanceof Date ? value : new Date(value)
    const validCurrent = Number.isNaN(current.getTime()) ? new Date() : current
    const currentDateKey = formatInTimeZone(validCurrent, REPORT_TIME_ZONE, 'yyyy-MM-dd')
    const { year, month, day } = parseDateKey(currentDateKey)
    const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay()
    const daysSinceMonday = (weekday + 6) % 7
    return getWeekWindowFromStartKey(shiftDateKey(currentDateKey, -daysSinceMonday))
}

export const getInquirySmsPeriodWindow = (periodValue) => (
    periodValue === 'all' ? null : getWeekWindowFromStartKey(periodValue)
)

export const buildInquirySmsPeriodOptions = (trackingStartAt, now = new Date()) => {
    const currentWeek = getInquirySmsWeekWindow(now)
    const trackingDate = trackingStartAt ? new Date(trackingStartAt) : null
    const earliestWeek = trackingDate && !Number.isNaN(trackingDate.getTime())
        ? getInquirySmsWeekWindow(trackingDate)
        : currentWeek
    const options = []
    let dateKey = currentWeek.startDateKey

    while (dateKey >= earliestWeek.startDateKey) {
        const window = getWeekWindowFromStartKey(dateKey)
        options.push({
            ...window,
            label: `${dateKey === currentWeek.startDateKey ? 'This week · ' : ''}${formatWeekLabel(window)}`,
        })
        dateKey = shiftDateKey(dateKey, -7)
    }

    options.push({ value: 'all', label: 'All Time', startAt: null, endAt: null })
    return options
}

const normalizeAdminName = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')

export const canDeleteNoSmsRecordedRows = (userData) => (
    normalizeAdminName(userData?.Name || userData?.name || userData?.userName)
    === 'prescott blackler'
)

export const filterRecordedResponseRows = (rows) => (
    Array.isArray(rows)
        ? rows.filter((row) => (
            !EXCLUDED_RECORDED_RESPONSE_ADMINS.has(
                normalizeAdminName(row?.responseActorName)
            )
        ))
        : []
)
